"use client";

import { usePath, useSearch } from "@packages/framework";
import { useCallback } from "react";

export const useUrl = () => {
  const path = usePath();
  const search = useSearch();

  const getUrl = useCallback(() => {
    return `${window.location.origin}${path}?${search.toString()}`;
  }, [path, search]);

  return { getUrl };
};
